// afficheurpalier2.js
import React from "react";
import NombreEnLettres from "./conver.js";

// Fonction : conversion du premier nombre en lettres (ex : "37,5" → "trente-sept virgule cinq")
const renderNombrePremierEnLettres = (premierNombreStr) => {
  const [intPartStr, decPartStr] = premierNombreStr.split(/[.,]/);
  const intPart = Number(intPartStr);

  // Pas de décimales → simple nombre
  if (!decPartStr) {
    return <><NombreEnLettres nombre={intPart} /></>;
  }

  // Cas avec décimale → "virgule X"
  const decPartNum = Number(decPartStr);
  return (
    <>
      <NombreEnLettres nombre={intPart} /> virgule{" "}
      <NombreEnLettres nombre={decPartNum} />
    </>
  );
};

// Extrait uniquement le premier nombre de la posologie
const extrairePremierNombre = (posologie) => {
  if (!posologie) return null;
  const avantSlash = posologie.split("/")[0]; // ex : "37,5 mg"
  const m = avantSlash.match(/(\d+(?:[.,]\d+)?)/);
  return m ? m[1] : null;
};

const AfficheurPalier2 = ({ donnee }) => {
  if (!donnee || !donnee.nom) return null;

  // --- Nouveau flux (Medic_interval_palier2) ---
  if (typeof donnee.texte === "string") {
    const premierNombreStr = extrairePremierNombre(donnee.posologie);
    const isLP =
      donnee.posologie && donnee.posologie.toUpperCase().includes("LP");

    return (
      <div style={{ fontSize: "100%" }}>
        <strong>
          {donnee.nom}
          {premierNombreStr && (
            <>
              {" "}
              {renderNombrePremierEnLettres(premierNombreStr)} mg
              {isLP && " libération prolongée"}
              {" "}
              ({donnee.posologie}) {/* Posologie complète dans la parenthèse */}
            </>
          )}
        </strong>
        {" : "}
        {donnee.texte}
        {Number(donnee.duree) > 0 ? (
          <>{" "}pendant <NombreEnLettres nombre={Number(donnee.duree)} /> jours</>
        ) : null}
      </div>
    );
  }

  // --- Ancien flux (compatibilité arrière) ---
  const {
    cp_gellule = false,
    nbs_cp1 = 0,
    nbs_cp2 = 0,
    poso1 = 0,
    poso2 = 0,
    intervalle = 0,
    duree = 0,
    nom,
  } = donnee;

  const safeInt = (v) => (isNaN(Number(v)) ? 0 : Number(v));

  const getIntervalleTexte = () => {
    const i = safeInt(intervalle);
    if (!i) return "";
    return i !== 1
      ? `à prendre si douleur, toutes les ${i} heures au maximum,`
      : "à prendre si douleur, toutes les heures au maximum,";
  };

  if (!cp_gellule) {
    const isLP = donnee.posologie && donnee.posologie.toUpperCase().includes("LP");

    return (
      <div style={{ fontSize: "100%" }}>
        <strong>
          {nom} <NombreEnLettres nombre={safeInt(poso1)} /> mg
          {isLP && " libération prolongée"}
          {" "}
          ({poso1} mg)
        </strong>
        {" : "}
        {safeInt(nbs_cp1) === 1 ? "un comprimé" : (
          <>
            <NombreEnLettres nombre={safeInt(nbs_cp1)} /> comprimés
          </>
        )}{" "}
        de <NombreEnLettres nombre={safeInt(poso1)} /> mg
        {safeInt(poso2) > 0
          ? ` et ${safeInt(nbs_cp2)} comprimé(s) de ${safeInt(poso2)} mg`
          : ""}
        , {getIntervalleTexte()} pendant <NombreEnLettres nombre={safeInt(duree)} /> jours
      </div>
    );
  }

  const isLPgel = donnee.posologie && donnee.posologie.toUpperCase().includes("LP");

  return (
    <div style={{ fontSize: "100%" }}>
      <strong>
        {nom} <NombreEnLettres nombre={safeInt(poso1)} /> mg
        {isLPgel && " libération prolongée"}
        {" "}
        ({poso1} mg)
      </strong>
      {" : "}
      {safeInt(nbs_cp1) === 1 ? "une gélule" : (
        <>
          <NombreEnLettres nombre={safeInt(nbs_cp1)} /> gélules
        </>
      )}{" "}
      de <NombreEnLettres nombre={safeInt(poso1)} /> mg
      {safeInt(poso2) > 0
        ? ` et ${safeInt(nbs_cp2)} gélule(s) de ${safeInt(poso2)} mg`
        : ""}
      , {getIntervalleTexte()} pendant <NombreEnLettres nombre={safeInt(duree)} /> jours
    </div>
  );
};

export default AfficheurPalier2;
